import { useRef, useEffect } from "react";

export function usePopupVideoAutoClose({ setShowPopup, showPopup }) {
  const videoRef = useRef(null);
  const popupTimeoutRef = useRef(null);

  // Make auto close timer cancellable
  const cancelPopupAutoClose = () => {
    if (popupTimeoutRef.current) {
      clearTimeout(popupTimeoutRef.current);
      popupTimeoutRef.current = null;
    }
  };

  const handlePlay = () => {
    cancelPopupAutoClose(); // cancel auto-close when replaying

    if (videoRef.current) {
      videoRef.current.play(); // Plays the video
    }
  };

  // Close video popup automatically after X seconds when video ends
  const handlePopupVideoEnded = (delaySeconds = 0) => {
    cancelPopupAutoClose();

    if (delaySeconds > 0) {
      popupTimeoutRef.current = setTimeout(() => {
        setShowPopup(false);
        popupTimeoutRef.current = null;
      }, delaySeconds * 1000);
    } else {
      setShowPopup(false);
    }
  };

  // Cancel auto-close when popup is closed manually
  useEffect(() => {
    if (!showPopup) {
      cancelPopupAutoClose();
    }
  }, [showPopup]);

  // Cleanup on unmount
  useEffect(() => {
    return () => cancelPopupAutoClose();
  }, []);

  return {
    videoRef,
    handlePlay,
    handlePopupVideoEnded,
    cancelPopupAutoClose
  };
}